import * as React from 'react';

import {Body} from '../typography/body';

import {getStatusText} from './helpers';
import type {Status} from './types';

import styles from './chat-preview.module.css';

type Props = {
    icon: React.ReactNode | string;
    headerTitle: string;
    subheader: string | null | undefined;
    backgroundColor: string;
    status: Status;
    isOnline?: boolean;
};

export function ChatHeader(props: Props) {
    return (
        <div style={{backgroundColor: props.backgroundColor}} className={styles['chat-header']}>
            <div>
                {typeof props.icon === 'string' ? (
                    <div className={styles['icon-avatar']}>{props.icon}</div>
                ) : (
                    props.icon
                )}
            </div>
            <div className='flex flex-dir-col'>
                <Body size={props.status === 'booking' ? 'mini' : 'small'} color='white'>
                    {props.headerTitle}
                </Body>
                <Body size={props.status === 'booking' ? 'small' : 'mini'} color='white'>
                    {props.subheader
                        ? props.subheader
                        : getStatusText(props.status, props.isOnline)}
                </Body>
            </div>
        </div>
    );
}
